exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".TagRepeater__tag-field-editor___2ifT0 label {\n  display: none; }\n\n.TagRepeater__btn-sm___16-hA {\n  position: relative;\n  margin-left: -28px; }\n", "", {"version":3,"sources":["/app/client/src/components/Backend/TagRepeater/TagRepeater.scss"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,mBAAmB,EAAE","file":"TagRepeater.scss","sourcesContent":[".tag-field-editor label {\n  display: none; }\n\n.btn-sm {\n  position: relative;\n  margin-left: -28px; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tag-field-editor": "TagRepeater__tag-field-editor___2ifT0",
	"btn-sm": "TagRepeater__btn-sm___16-hA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/components/Backend/TagRepeater/TagRepeater.scss
// module id = 452
// module chunks = 0